/** Формат даты в календаре */
export var DATE_VIEW_FORMAT = "DD.MM.YYYY";
/** Формат даты для бэка */
export var DATE_SERV_FORMAT = "YYYY-MM-DD";
/** Список месяцев с именительном падеже */
export var MONTHS_LIST = [
    "январь",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь",
];
/** Секунды для валидации токена в updateToken */
export var MIN_VALIDITY_KEYCLOAK = 30;
